import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csobjectinit(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# object initializer tutorial For Beginners</title>
 <meta name="description" content="C# object initializer tutorial for beginners.There are 3 Types of object initializer in C# ,CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language, by using constructor in C#,tutorial for begineers,by using a method in C#,Reference variable in c#,C# object initializer,c# object initializer for,c sharp object initializer,c# object initializer for loop,end for loop c#," />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-object-initializers" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Types of object initialization C#</h1>
    <div className="first">
        <a href="/csharp-passing-argument">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-constructor">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">1, by the reference variable in C#<br/>
2, by using a method in C#<br/>
3, by using constructor in C#<br/>
</h2>

<h3 className="mt-4"> Reference Variable in C#:</h3>



<h2 className="headings">Q-Write a Program and Print int and name in Reference variable in C# Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">class </span>
            <span className="qwerty">Human </span>
            <span className="qwerty-2">&#123;</span>
            {"\n"}
            <span className="qwerty-7">int </span>
            <span className="qwerty-5">age</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">String </span>
            <span className="qwerty-2">name</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-6">void </span>
            <span className="qwerty-1">main </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-1">[]</span>
            <span className="qwerty">args</span>
            <span className="qwerty-2">)</span>
            {"\n"}
            <span className="qwerty-2">&#123;</span>
            {"\n"}
            <span className="qwerty">Human</span>
            <span className="qwerty-5"> h</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-7">new </span>
            <span className="qwerty">Human</span>
            <span className="qwerty-2">()</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5">h.age </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-4">160208</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">h.name</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-6">codeExampler</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">Console.</span>
            <span className="qwerty-2">WriteLine</span>
            <span className="qwerty-6">(</span>
            <span className="qwerty-5">h.age</span>
            <span className="qwerty-1"> +" "+ </span>
            <span className="qwerty-7">h.name</span>
            <span className="qwerty-6">)</span>
            <span className="qwerty-3">; </span>
            {"\n"} 
            <span className="qwerty-2">&#125;</span>
            {"\n"}
            <span className="qwerty-2">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">160208 </span>
            <span className="qwerty-6">codeExampler </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className="headings">Q-Reference variable in C# Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">class </span>
            <span className="qwerty-4">school </span>
            {"\n"}
            <span className="qwerty-2">&#123;</span>
            {"\n"}
            <span className="qwerty-4">int </span>
            <span className="qwerty-5">teachers </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> // </span>
            <span className="qwerty-2">no of teachers </span>
              {"\n"}
              <span className="qwerty-4">int </span>
            <span className="qwerty-5">students </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> // </span>
            <span className="qwerty-2">no of students </span>
              {"\n"}
              <span className="qwerty-4">int</span>
            <span className="qwerty-5"> peon </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> // </span>
            <span className="qwerty-2">no of peon </span>
              {"\n"}  {"\n"}
              <span className="qwerty-1"> // </span>
              <span className="qwerty-2">This class declares an object of type school. </span>
              {"\n"} {"\n"}
            <span className="qwerty-7">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-6">void </span>
            <span className="qwerty-1">main </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-5">string</span>
            <span className="qwerty-1">[]</span>
            <span className="qwerty">args</span>
            <span className="qwerty-2">)</span>
              {"\n"}
              <span className="qwerty-4">&#123;</span>
              {"\n"}
            <span className="qwerty-5">school </span>
            <span className="qwerty-6">sch</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-7">new </span>
            <span className="qwerty-6">school </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">; </span>
              {"\n"}
            <span className="qwerty-6">sch </span>
            <span className="qwerty-5">.teachers</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">40</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-6">sch </span>
            <span className="qwerty-5">.students</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">500</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-6">sch </span>
            <span className="qwerty-5">.peon</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">20</span>
            <span className="qwerty-3">; </span>
              {"\n"} {"\n"}
            <span className="qwerty-1">// </span>
            <span className="qwerty-2">This dot operator (.) is used to access the member</span>
            {"\n"} {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch.teachers </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> teachers </span>
            <span className="qwerty-7">in this school </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch.students </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> students </span>
            <span className="qwerty-7">in this school </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch.peon </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> peon </span>
            <span className="qwerty-7">in this school </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-4">there are </span>
              <span className="qwerty-6">40 </span>
              <span className="qwerty-5">teachers </span>
              <span className="qwerty-2">in this school </span>
              {"\n"}
              <span className="qwerty-4">there are </span>
              <span className="qwerty-6">500</span>
              <span className="qwerty-5"> students</span>
              <span className="qwerty-2"> in this school </span>
              {"\n"}
              <span className="qwerty-4">there are </span>
              <span className="qwerty-6">20 </span>
              <span className="qwerty-5">peon </span>
              <span className="qwerty-2">in this school </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-create 2 object class and Initilize in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">class </span>
            <span className="qwerty-4">school </span>
            <span className="qwerty-2">&#123;</span>
            {"\n"}
            <span className="qwerty-4">int </span>
            <span className="qwerty-5">teachers </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> // </span>
            <span className="qwerty-2">no of teachers </span>
              {"\n"}
              <span className="qwerty-4">int </span>
            <span className="qwerty-5">students </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> // </span>
            <span className="qwerty-2">no of students </span>
              {"\n"}
              <span className="qwerty-4">int</span>
            <span className="qwerty-5"> peon </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-1"> // </span>
            <span className="qwerty-2">no of peon </span>
              {"\n"}  {"\n"}
              <span className="qwerty-1"> // </span>
              <span className="qwerty-2">This class declares an object of type school. </span>
              {"\n"} {"\n"}
            <span className="qwerty-7">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-6">void </span>
            <span className="qwerty-1">main </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-5">string</span>
            <span className="qwerty-1">[]</span>
            <span className="qwerty">args</span>
            <span className="qwerty-2">)</span>
              {"\n"}
              <span className="qwerty-4">&#123;</span>
              {"\n"}
            <span className="qwerty-5">school </span>
            <span className="qwerty-6">sch1</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-7">new </span>
            <span className="qwerty-6">school </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-5">school </span>
            <span className="qwerty-6">sch2</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-7">new </span>
            <span className="qwerty-6">school </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">; </span>
              {"\n"}{"\n"}
              <span className="qwerty-1">// </span>
            <span className="qwerty-2">Sch1 and sch2 Both are different objects</span>
            {"\n"}
            <span className="qwerty-1">//</span>
            <span className="qwerty-2"> assigns value inside the sch1 fields</span>
            {"\n"}{"\n"}
            <span className="qwerty-6">sch1 </span>
            <span className="qwerty-5">.teachers</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">40</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-6">sch1 </span>
            <span className="qwerty-5">.students</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">500</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-6">sch1 </span>
            <span className="qwerty-5">.peon</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">20</span>
            <span className="qwerty-3">; </span>
              {"\n"} {"\n"}
              <span className="qwerty-1">//</span>
            <span className="qwerty-2"> assigns value inside the sch2 fields </span>
            {"\n"}{"\n"}
            <span className="qwerty-6">sch2 </span>
            <span className="qwerty-5">.teachers</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">20</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-6">sch2 </span>
            <span className="qwerty-5">.students</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">250</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-6">sch2 </span>
            <span className="qwerty-5">.peon</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">10</span>
            <span className="qwerty-3">; </span>
              {"\n"}{"\n"}
            <span className="qwerty-1">// </span>
            <span className="qwerty-2">This dot operator (.) is used to access the member</span>
            {"\n"} {"\n"}
            <span className="qwerty-1">// </span>
              <span className="qwerty-6">sch1.</span>
              {"\n"}{"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch1.teachers </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> teachers </span>
            <span className="qwerty-7">in this school </span>
            <span className="qwerty-6">1 </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch1.students </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> students </span>
            <span className="qwerty-7">in this school </span>
            <span className="qwerty-6">1 </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch1.peon </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> peon </span>
            <span className="qwerty-7">in this school </span>
            <span className="qwerty-6">1 </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"} {"\n"}
            <span className="qwerty-1">// </span>
              <span className="qwerty-6">sch2.</span>
            {"\n"} {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch2.teachers </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> teachers </span>
            <span className="qwerty-7">in this school </span>
            <span className="qwerty-6">2 </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch2.students </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> students </span>
            <span className="qwerty-7">in this school </span>
            <span className="qwerty-6">2 </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-2">("</span>
              <span className="qwerty-6">there are </span>
            <span className="qwerty-1">"+ </span>
            <span className="qwerty">sch2.peon </span>
            <span className="qwerty-1">+"</span>
            <span className="qwerty-5"> peon </span>
            <span className="qwerty-7">in this school </span>
            <span className="qwerty-6">2 </span>
              <span className="qwerty-2">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
              <span className="qwerty-4">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-4">there are </span>
              <span className="qwerty-6">40 </span>
              <span className="qwerty-5">teachers </span>
              <span className="qwerty-2">in this school </span>
              <span className="qwerty-6">1</span>
              {"\n"}
              <span className="qwerty-4">there are </span>
              <span className="qwerty-6">500</span>
              <span className="qwerty-5"> students</span>
              <span className="qwerty-2"> in this school </span>
              <span className="qwerty-6">1</span>
              {"\n"}
              <span className="qwerty-4">there are </span>
              <span className="qwerty-6">20 </span>
              <span className="qwerty-5">peon </span>
              <span className="qwerty-2">in this school </span>
              <span className="qwerty-6">1</span>
              {"\n"}   {"\n"}
              <span className="qwerty-4">there are</span>
              <span className="qwerty-6"> 20</span>
              <span className="qwerty-5"> teachers</span>
              <span className="qwerty-2"> in this school </span>
              <span className="qwerty-6">2</span>
              {"\n"}
              <span className="qwerty-4">there are </span>
              <span className="qwerty-6">250 </span>
              <span className="qwerty-5">students</span>
              <span className="qwerty-2"> in this school</span>
              <span className="qwerty-6"> 2 </span>
              {"\n"}
              <span className="qwerty-4">there are </span>
              <span className="qwerty-6">10 </span>
              <span className="qwerty-5">peon</span>
              <span className="qwerty-2"> in this school </span>
              <span className="qwerty-6">2</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">2,Using method:</h2>



<h2 className="headings">Q-Reference variable by Using Method in c# example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">class </span>
            <span className="qwerty-4">school </span>
            {"\n"}
            <span className="qwerty-2">&#123;</span>
            {"\n"}
            <span className="qwerty-3">int </span>
            <span className="qwerty-5">teachers </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">int </span>
            <span className="qwerty-2">students </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">void</span>
            <span className="qwerty"> numbers </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-3">int </span>
            <span className="qwerty-2">t</span>
            <span className="qwerty-2">,</span>
            <span className="qwerty-3">int </span>
            <span className="qwerty-2">s</span>
            <span className="qwerty-1">)</span>
            {"\n"} 
            <span className="qwerty-2">&#123;</span>
            {"\n"}
            <span className="qwerty-5">teachers</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">t</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-2">students</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-2">s</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-2">&#125;</span>
            {"\n"}
            <span className="qwerty-6">void</span>
            <span className="qwerty-5"> show</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}
            <span className="qwerty-2">&#123;</span>
            {"\n"}
            <span className="qwerty-1">Console.</span>
            <span className="qwerty-2">WriteLine</span>
            <span className="qwerty-6">(</span>
            <span className="qwerty-5">teachers</span>
            <span className="qwerty-1"> +" "+ </span>
            <span className="qwerty-2">students</span>
            <span className="qwerty-6">)</span>
            <span className="qwerty-3">; </span>
            {"\n"} 
            <span className="qwerty-2">&#125;</span>
            {"\n"}
            <span className="qwerty-7">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-6">void </span>
            <span className="qwerty-1">main </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-5">string</span>
            <span className="qwerty-1">[]</span>
            <span className="qwerty">args</span>
            <span className="qwerty-2">)</span>
            {"\n"}
            <span className="qwerty-2">&#123;</span>
            {"\n"}
            <span className="qwerty-4">school </span>
            <span className="qwerty-7">sch </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-6">new </span>
            <span className="qwerty-4">school</span>
            <span className="qwerty-2">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">sch.</span>
            <span className="qwerty">numbers </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-4">40,</span>
            <span className="qwerty-6">400</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">sch.</span>
            <span className="qwerty-3">show </span>
            <span className="qwerty-2">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">&#125;</span>
            {"\n"}
            <span className="qwerty-2">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">40 </span>
            <span className="qwerty-6">400 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


  <h1 className="mt-5">  </h1>
       
  <div className="back">
        <a href="/csharp-passing-argument">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-constructor">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csobjectinit;